// components/SkeletonFAQItem.tsx
export default function SkeletonFAQItem() {
  return (
    <div className='w-full py-3 animate-pulse'>
      <div className='flex justify-between items-center'>
        <div className='h-4 w-3/4 bg-gray-300 rounded-md' />
        <div className='h-4 w-4 bg-gray-300 rounded-md' />
      </div>
      <div className='mt-2 h-3 w-full bg-gray-200 rounded-md' />
      <div className='mt-1 h-3 w-5/6 bg-gray-200 rounded-md' />
    </div>
  );
}
